import { render } from "./CustomCategoryFolderListViewEditItemPane.vue?vue&type=template&id=77b6c482&scoped=true&ts=true"
import script from "./CustomCategoryFolderListViewEditItemPane.vue?vue&type=script&lang=ts"
export * from "./CustomCategoryFolderListViewEditItemPane.vue?vue&type=script&lang=ts"

import "./CustomCategoryFolderListViewEditItemPane.vue?vue&type=style&index=0&id=77b6c482&scoped=true&lang=css"

import exportComponent from "D:\\Ventla Code\\New Admin\\node_modules\\@vue\\cli-service\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-77b6c482"]])

export default __exports__